<template>
  <div>
    <div class="container mb-5">
      <div class="row justify-content-center">
        <h2 class="text-center mb-3"><br />¿QUIÉNES SOMOS? <br /></h2>
      </div>
      <div class="row justify-content-center">
        <h4 class="text-politics">
          DESARROLLO Y CONSULTORÍA TECNOLÓGICA PARA SOLUCIONES INTEGRALES FYF,
          también conocido como FYF SOLUCIONES o ALL SOLUTIONS, con domicilio en
          CALLE ANDADOR AUSTRIA NÚMERO EXTERIOR 6 NÚMERO INTERIOR PISO 1 ENTRE
          CALLE DINAMARCA Y CALLE ALEMANIA COLONIA CENTRO URBANO LOCALIDAD
          CUAUTITLÁN IZCALLI MUNICIPIO CUAUTITLÁN IZCALLI ENTIDAD FEDERATIVA
          MÉXICO, y portal de internet administracion@fyf.mx, es el responsable
          del uso y protección de sus datos personales, y al respecto le
          informamos lo siguiente: <br />
        </h4>
      </div>
      <div class="row justify-content-center">
        <h2 class="text-center mb-3">
          <br />¿PARA QUÉ FINES UTILIZAREMOS SUS DATOS PERSONALES? <br />
        </h2>
      </div>
      <div class="row justify-content-center">
        <h4 class="text-politics">
          Los datos personales que recabamos de usted serán utilizados para las siguientes finalidades principales,
          que son necesarias para el funcionamiento de nuestra aplicación Scan VI:
          <br>
          Permitir el acceso y uso de la cámara del dispositivo para el escaneo de códigos y captura de imágenes relacionadas
          con el proceso de identificación o registro de puntos de venta.
          <br>
          Obtener y utilizar su ubicación geográfica (GPS) para proporcionar funcionalidades de rutaje, navegación y localización de puntos de venta cercanos.
          <br>
          Optimizar las rutas y mejorar la experiencia de uso en función de su ubicación actual.
          <br>
          De manera adicional, utilizaremos su información personal para las siguientes finalidades secundarias que no son necesarias para el servicio solicitado, pero que nos permiten y facilitan brindarle una mejor atención:
          <br>
          Fines comerciales y estadísticos internos.
          <br>
          Contacto para seguimiento o evaluación del uso del servicio.
          <br>
          En caso de que no desee que sus datos personales sean tratados para estas finalidades secundarias, puede manifestarlo enviando un correo a administracion@fyf.mx
          indicando su decisión.
          <br>
          La negativa para el uso de sus datos personales con fines secundarios no será motivo para negarle el acceso o uso de la aplicación.
        </h4>
      </div>
      <div class="row justify-content-center">
        <h2 class="text-center mb-3">
          <br />¿QUÉ DATOS PERSONALES UTILIZAMOS?
          <br />
        </h2>
      </div>
      <div class="row justify-content-center">
        <h4 class="text-politics">
          Para llevar a cabo las finalidades descritas, podremos solicitar o hacer uso de los siguientes datos personales:
          <br>
          Datos de identificación (como nombre de usuario o correo electrónico, si aplica).
          <br>
          Datos de ubicación geográfica (GPS).
          <br>
          Imágenes o códigos capturados mediante la cámara del dispositivo.
        </h4>
      </div>
      <div class="row justify-content-center">
        <h2 class="text-center mb-3">
          <br />¿CÓMO PUEDE ACCEDER, RECTIFICAR O CANCELAR SUS DATOS PERSONALES, U OPONERSE A SU USO?
          <br />
        </h2>
      </div>
      <div class="row justify-content-center">
        <h4 class="text-politics">
          Usted tiene derecho a conocer qué datos personales tenemos de usted, para qué los utilizamos y las condiciones del uso que les damos (Derechos ARCO). Asimismo, puede solicitar la rectificación, cancelación u oposición de su información personal enviando una solicitud a administracion@fyf.mx, donde será atendida conforme a los plazos y procedimientos establecidos por la ley.
        </h4>
      </div>
      <div class="row justify-content-center">
        <h2 class="text-center mb-3">
          <br />¿DÓNDE PUEDO CONSULTAR EL AVISO DE PRIVACIDAD INTEGRAL? <br />
        </h2>
      </div>
      <div class="row justify-content-center">
        <h4 class="text-politics">
          Para conocer mayor información sobre los términos y condiciones en que serán tratados sus datos personales, como los terceros con quienes compartimos su información y la forma en que podrá ejercer sus derechos ARCO, puede consultar el aviso de privacidad integral enviando una solicitud al correo administracion@fyf.mx
          o a través de nuestro sitio web oficial, cuando esté disponible.
        </h4>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AvisoDePrivacidadv2"
};
</script>

<style scoped>
.title {
  font-size: 20px;
  color: blue;
  margin-bottom: 10px;
}

.content {
  font-size: 16px;
  color: black;
  margin-bottom: 20px;
}
.text-politics {
  text-align: justify;
}
</style>
